<template>
  <div
      data-grm-comp="Battery"
      v-if="isSupported"
  >
    <div v-if="charging">[{{ $t('camstudy.battery.charging') }}]<span>{{currentLevel}}%</span></div>
    <div v-else>
      <span>{{currentLevel}}%,</span>
      <span> {{calc.total.elapsedMinutes}}{{ $t('camstudy.battery.minutesUsing') }},</span>
      <span> {{currentLevel - calc.total.level}}% {{ $t('camstudy.battery.used') }},</span>
      <span> {{calc.total.remainMinutes > 0 ? calc.total.remainMinutes : '-'}}{{ $t('camstudy.battery.minutesRemaining') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Battery',
  data () {
    return {
      supported: false,
      calc: {
        total: {
          time: -1,
          level: -1,
          usagePerMinute: 0,
          elapsedMinutes: 0,
          remainMinutes: 0,
        },
        recent: {
          criMinutes: 10,
          time: -1,
          level: -1,
          usagePerMinute: 0,
          elapsedMinutes: 0,
          remainMinutes: 0,
        },
      },
      charging: false,
      lastChargingTime: -1,
      lastCheckTime: -1,
      currentLevel: -1,
    }
  },
  computed: {
    isSupported: function(){
      return !!navigator.getBattery;
    }
  },
  created () {
    this.init();
  },
  mounted () {},
  methods: {
    async init () {
      const battery = await navigator.getBattery();
      this.battery = battery;

      battery.removeEventListener('chargingchange', this.onChargingChange);
      battery.addEventListener('chargingchange', this.onChargingChange);

      battery.removeEventListener('levelchange', this.updateStatus);
      battery.addEventListener('levelchange', this.updateStatus);

      this.onChargingChange();
      this.updateStatus();
    },
    onChargingChange (e) {
      const {battery} = this;
      this.charging = battery.charging;
      const { total } = this.calc;
      if(!this.charging){ // 충전 중단
        const now = Date.now();
        if(now - this.lastChargingTime < 1000*10){
          return;
        }
        this.lastChargingTime = now;

        Object.assign(total, {
          level: battery.level * 100,
          time: Date.now(),
        });
        this.currentLevel = total.level;
        this.lastCheckTime = total.time;
      }else{
        // 충전 시작
      }
    },
    updateStatus() {
      const {battery, chkTime, chkLevel} = this;
      const currLevel = this.currentLevel = battery.level * 100;
      const now = this.lastCheckTime = Date.now();

      if(battery.charging){
        return
      }

      // total
      const calc = (initTime, initLevel, data, criMinutes) => {
        if(initTime === -1){
          Object.assign(data, {
            level: currLevel,
            time: now
          });
          return false;
        }

        let elapsedMinutes = parseInt((now - initTime) / 60000); // 경과시간(분)
        if(criMinutes && elapsedMinutes < criMinutes) return false;
        if(elapsedMinutes < 1){
          return false;
        }

        let used = currLevel - initLevel;
        let usagePerMinute = used / elapsedMinutes;
        let remainMinutes = parseInt(currLevel / usagePerMinute);
        Object.assign(data, {
          elapsedMinutes,
          remainMinutes
        });
        return true;
      };

      const {total, recent} = this.calc;
      calc(
        total.time, total.level,
        total
      );

      if(calc(
        recent.time, recent.level,
        recent,
        recent.criMinutes
      )){
        Object.assign(recent, {
          time: now,
          level: currLevel
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>